export enum EInstallmentCalculatorProduct {
  BNPL_SBER_BUSINESS = 'BNPL_SBER_BUSINESS',
  BNPL_AGROINTEGRATOR = 'BNPL_AGROINTEGRATOR',
  BNPL_MONEY_KAPITAL = 'BNPL_MONEY_KAPITAL',
  BNPL_POLECREDIT = 'BNPL_POLECREDIT',
}
